import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Row, Spinner } from 'reactstrap';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Title from '../../../sharedComponents/Title/Title';
import useDataSuite from '../useDataSuite';
import { AutoSizer, Column, Table } from 'react-virtualized';
import { tableColors, Theme } from '../../../config/constants';
import { FaTrash, FaCircle, FaClipboardList } from 'react-icons/fa';
import { BsPencilSquare } from 'react-icons/bs';
import { IoMdInformationCircle } from "react-icons/io";
import { Tooltip } from "@mui/material";
import useDataSuiteWidgets from './useDataSuiteWidgets';
import EmptyDataMessage from '../../../sharedComponents/ErrorMessages/EmptyDataMessage';
import { isMobileOnly } from 'react-device-detect';

ChartJS.register(...registerables);

const SalesByCategoryWidget = (props) => {
    const { w, i } = props;
    const { onClickWidgetDrawerOpen, onClickDeleteWidget } = useDataSuite.useWidgetControls();
    const { widgetTitle, tableOptions, salesByCategoryBarData, salesByCategoryTableLabels, sortedDetailsTableData } = useDataSuiteWidgets.useSalesByCategoryWidget();
    const { onClickViewDetails } = useDataSuite.useDataSuite();
    const widgetOptionsOpen = useSelector(({ui}) => ui.slideDrawer);
    const isLoading = useSelector(({datasuite}) => datasuite.isLoading.salesByCategoryLoading);
    const [isWidgetHovered, setIsWidgetHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsWidgetHovered(true);
    };
    const handleMouseLeave = () => {
        setIsWidgetHovered(false);
    };

    return (
        <Col onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ position: 'relative'}} >
            <Row className='d-flex align-items-center'>
                <Col className='w-fc pr-0'>
                    <div className='d-flex align-items-center px-0'>
                    <Title title={widgetTitle}/>
                    {!isMobileOnly &&
                    <Tooltip title='Displays your sales by your relevant categories. Helpful for identifying category growth opportunities as well as verifying compliance data. Information is up-to-date and updated daily.' arrow>
                        <div className='pt-3 pb-2'>
                        <IoMdInformationCircle className="text-size-18 " style={{color: Theme().colors.accent}}/>
                        </div>
                    </Tooltip>
            }
                    </div>
                </Col>
                {(widgetOptionsOpen || isWidgetHovered)  && ( <>
                    <Col className='w-fc px-1 pt-3 pb-2'>
                        <Button
                            block
                            className='py-1 button-label replaceWidgetButton'
                            size='sm'
                            color='blueFilter'
                            onClick={() => onClickWidgetDrawerOpen("Replace Widget", true, i)}>
                            <BsPencilSquare color='white' />
                        </Button>
                    </Col>
                    <Col className='w-fc px-1 pt-3 pb-2'>
                        <Button
                            block
                            className='py-1 button-label deleteWidgetButton'
                            size='sm'
                            color='redLight'
                            onClick={() => onClickDeleteWidget(w)}>
                            <FaTrash color='white' />
                        </Button>
                    </Col>
                </>
                )}
                <Col className={`w-fc me-3 ms-auto px-1 pt-3 pb-2`}>
                <Button
                    block
                    className={`py-1 button-label expandWidgetButton`}
                    size='sm'
                    outline={true}
                    color={Theme().colors.accentName}
                    onClick={() => onClickViewDetails(widgetTitle, props.prechosenFilters)}>
                    <FaClipboardList color={Theme().colors.accentName} style={{position: 'relative', bottom: '1px'}}/> View Details
                </Button>
                </Col>
            </Row>
            {isLoading &&
              <Row className="mx-auto" style={{minHeight: '315px'}}>
                  <Col className="mx-auto my-auto" style={{width:"2.5%"}}>
                      <Spinner style={{marginLeft:'50%'}} color='beplBlue' animation="border" />
                  </Col>
              </Row>
            }
            {(sortedDetailsTableData?.length <= 0) && !isLoading &&
            <Row className="mx-auto" style={{minHeight: '315px'}}>
                <Col className="mx-auto my-auto" style={{width:"2.5%"}}>
                    <EmptyDataMessage />
                </Col>
            </Row>
            }
            {(sortedDetailsTableData?.length > 0) && !isLoading &&
            <Row className="w-100 mb-3 mx-0" style={{minHeight: '315px', height: '315px'}}>
                <Col className='my-auto' style={{height: '100%', width: '50%', maxWidth: '50%', flex: '0 0 50%'}}>
                    <div style={{height: '100%'}}>
                        <Bar
                            data = {{
                                labels: salesByCategoryTableLabels,
                                datasets: [
                                    {
                                        label: '',
                                        data: salesByCategoryBarData,
                                        backgroundColor: tableColors
                                    }
                                ]
                            }}
                            options = {{ ...tableOptions, maintainAspectRatio: false }}
                        />
                    </div>
                </Col>
                <Col style={{height: '100%', width: '50%', maxWidth: '50%', flex: '0 0 50%'}}>
                    <AutoSizer>
                        {({width, height}) => (
                            <Table className="table salesByCategoryTable border-grayLight" id="salesByCategoryTable"
                                width={width}
                                height={height}
                                headerHeight={34.5}
                                rowHeight={30}
                                rowCount={salesByCategoryTableLabels.length}
                                rowGetter={({ index }) => salesByCategoryTableLabels[index]}
                            >
                                <Column
                                label='Category'
                                dataKey='salesByCategoryTableLabels'
                                width={width}
                                cellRenderer={({cellData, rowIndex}) => (<span><FaCircle className='w-fc my-auto' style={{color: tableColors[rowIndex]}}/> {salesByCategoryTableLabels[rowIndex]}</span>)}
                                />
                            </Table>
                        )}
                    </AutoSizer>
                </Col>
            </Row>
            }
        </Col>
    );

}

export default SalesByCategoryWidget;
